package com.hyperether.goodjob.database

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Plan(
  public val id: Long,
  public val _id: String?,
  public val name: String?,
  public val price: Double?,
  public val perMonth: Double?,
  public val description: String?,
  public val storage: String?,
  public val planSupport: String?,
  public val limitUsers: Long?,
  public val limitManagers: Long?,
  public val isPopular: Long?,
  public val currency: String?,
  public val interval: String?,
  public val stripeProductId: String?,
  public val stripePriceId: String?,
  public val type: String?,
  public val descriptions: String?,
  public val names: String?,
  public val storages: String?,
  public val planSupports: String?,
)
